import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    tasks: []
};

const taskSlice = createSlice({
    name: "tasks",
    initialState,
    reducers: {
        // ✅ Добавление одной задачи
        addTask: (state, action) => {
            state.tasks.push(action.payload);
        },

        // ✅ Добавление нескольких задач
        addMultipleTasks: (state, action) => {
            state.tasks = [...state.tasks, ...action.payload]; // Добавляем массив задач
        },

        // ✅ Удаление одной задачи по title
        removeTask: (state, action) => {
            state.tasks = state.tasks.filter(task => task.details !== action.payload);
        },

        removeTaskById: (state, action) => {
            state.tasks = state.tasks.filter(task => task.id !== action.payload);
        },

        // ✅ Удаление нескольких задач по массиву title
        removeMultipleTasks: (state, action) => {
            state.tasks = state.tasks.filter(task => !action.payload.includes(task.title));
        },

        // ✅ Очистка всех задач
        clearTasks: (state) => {
            state.tasks = [];
        }
    }
});

// Экспортируем экшены
export const {addTask, addMultipleTasks, removeTask, removeMultipleTasks, clearTasks,removeTaskById} = taskSlice.actions;

// Экспортируем сам slice
export default taskSlice.reducer;
